import { useParams } from "react-router-dom";

const ProviderPage = () => {
  const { provider } = useParams();
  return <h1>{provider}</h1>;
};

export default ProviderPage;
